import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { enterAnalyticsPage, leaveAnalyticsPage } from "../redux/navigationSlice";

/* ---------------- Module-scope helpers (run once) ---------------- */

  function isBot() {
    if (typeof navigator === "undefined") return true; 

    if (window.location.hostname === "localhost" || 
      window.location.hostname === "127.0.0.1" || 
      window.location.hostname === "[::1]") {
    return false;
  }

    const botUserAgent = /headless|bot|crawler|spider|fetch|httpclient|python|java/i.test(
      navigator.userAgent || navigator.userAgentData?.brands?.map(b => b.brand).join(" ") || ""
    );

    const isHeadless = navigator.webdriver || !("onload" in new Image());

    return botUserAgent || isHeadless;
  }

function sanitizePath(pathname) {
  try {
    // ensure string
    let p = String(pathname || "/");

    // decode repeatedly to collapse double-encoding, but cap iterations
    for (let i = 0; i < 2; i++) {
      try { p = decodeURIComponent(p); } catch { break; }
    }

    // strip control chars, collapse spaces, multiple slashes
    p = p.replace(/[\u0000-\u001F\u007F]/g, "").replace(/\s+/g, " ").replace(/\/{2,}/g, "/");

    // enforce leading slash, remove trailing except root
    if (!p.startsWith("/")) p = "/" + p;
    if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);

    // cap length to avoid log spam
    if (p.length > 300) p = p.slice(0, 300) + "…";

    return p;
  } catch {
    return "/";
  }
}

const NavigationTracker = () => {
  const location = useLocation(); 
  const dispatch = useDispatch();

  // Normal function outside useEffect to send analytics
  function sendAnalyticsBeacon(analyticsEvent) {
    const url = "/api/realtime-analytics";
    const data = JSON.stringify(analyticsEvent);

    const getLocalStorageItem = (key) => {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        console.warn("localStorage blocked", e);
        return undefined;
      }
    };

    const userAddress = getLocalStorageItem("userAddress") || undefined;
    const selectedNetwork = getLocalStorageItem("selectedNetwork") || "mainnet";

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-User-Address": userAddress || "",  // Include if available
          "X-Network": selectedNetwork || "mainnet",  // Default to mainnet if not selected
        },
        credentials: "include",
        body: data,
      })

        .then((response) => {
          if (!response.ok) {
            //console.error("Fallback fetch failed:", response.status, response.statusText);
          } else {
            //console.log("Fallback fetch successful");
          }
        })
        .catch((error) => console.error("Fallback fetch error:", error));
    } 

  useEffect(() => {

    if (isBot()) {
      //console.log("Bot detected, skipping analytics.");
      return;
    }

    const currentPath = sanitizePath(location.pathname);
    const referringUrl = document.referrer || "direct";

    let loadTime = 0;

    const navigationTiming = performance.getEntriesByType("navigation")[0] || performance.timing;

    if (navigationTiming) {
      loadTime = (navigationTiming.loadEventEnd - navigationTiming.startTime).toFixed(2);
      loadTime = isNaN(loadTime) ? 0 : parseFloat(loadTime);
    }

    //console.log("Accurate load time (ms):", loadTime);

    const analyticsEvent = {
      type: "analytics",
      page: currentPath || "/",
      timestamp: new Date().toISOString(),
      referringUrl,
      loadTime,
      screenWidth: window.screen.width || 0,
      screenHeight: window.screen.height || 0,
    };

    // Track analytics page state
    if (
      location.pathname === "/analytics" ||
      location.pathname === "/analytic"
    ) {
      dispatch(enterAnalyticsPage());
    } else {
      dispatch(leaveAnalyticsPage()); 
    }

      sendAnalyticsBeacon(analyticsEvent);  

      //console.log("Initial analytics sent:", analyticsEvent);
    
  }, [location.pathname, dispatch,]);

  return null;
};

export default NavigationTracker;
